"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedBoard = ThemedBoard;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const board_1 = require("~/components/board");
const useStyles = (0, react_jss_1.createUseStyles)({
    lightTile: {
        background: ({ theme = "default" }) => {
            switch (theme) {
                case "default":
                    return "#a7f070";
                default:
                    return "#fff";
            }
        },
    },
    darkTile: {
        background: ({ theme = "default" }) => {
            switch (theme) {
                case "default":
                    return "#38b764";
                default:
                    return "#000";
            }
        },
    },
});
function ThemedBoard(props) {
    const styles = useStyles(props);
    return (react_1.default.createElement(board_1.BoardGrid, { state: props.state, renderItem: props.renderItem, renderTileBackground: props.renderTileBackground, dragDrop: props.dragDrop, onDropItem: props.onDropItem, onClickTile: props.onClickTile, canDropItem: props.canDropItem, lightTileClassName: props.flipDarkLight ? styles.darkTile : styles.lightTile, darkTileClassName: props.flipDarkLight ? styles.lightTile : styles.darkTile }));
}
